import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { TITLE_OPTIONS } from 'utils/enums'
import { FieldRow, FieldRowItem, TitleFieldRowItem } from './field-row'

type Props = {
  handleSave: (event: { name: string; value: string | number | null }) => void
}

const PersonNameFields = ({ handleSave }: Props) => (
  <Grid.Item span={12}>
    <FieldRow>
      <TitleFieldRowItem>
        <InputFloating
          name="title"
          label="Title"
          component="select"
          options={TITLE_OPTIONS}
          handleSave={handleSave}
        />
      </TitleFieldRowItem>
      <FieldRowItem>
        <InputFloating
          name="firstNames"
          label="First names"
          handleSave={handleSave}
        />
      </FieldRowItem>
      <FieldRowItem>
        <InputFloating
          name="lastName"
          label="Last name"
          handleSave={handleSave}
        />
      </FieldRowItem>
    </FieldRow>
  </Grid.Item>
)

export default PersonNameFields
